import createRulesObject from '@/utils/functions/tasklist/createRulesObject';
import classNames from 'classnames';
import _ from 'lodash';
import { Controller } from 'react-hook-form';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
import moment from 'moment';

export default function InputDateFlat({ fieldSpec, value, control, setValue }: any) {
  const rulesObject = createRulesObject(fieldSpec);

  return (
    <div>
      <label
        className={classNames('font-medium', {
          'after:content-["*"] after:text-red-400 after:text-sm': fieldSpec.constraints?.required,
        })}
        htmlFor={fieldSpec.name}
      >
        {fieldSpec.label}
      </label>
      <Controller
        name={fieldSpec.name}
        control={control}
        rules={rulesObject}
        render={({ fieldState }) => {
          return (
            <>
              <Flatpickr 
                onChange={e => {
                  const date = moment(e[0]).format('YYYY-MM-DD');
                  setValue(fieldSpec.name, date);
                }}
                options={{
                  dateFormat: 'd/m/y',
                }}
                data-testid="flatpickr-id"
                className='input border border-[#c4c4c480] h-11 focus:ring-indigo-600 focus-within:ring-indigo-600 focus-within:border-indigo-600 focus:border-indigo-600'></Flatpickr>
              {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
            </>
          );
        }}
      ></Controller>
    </div>
  );
}
